import classNames from 'classnames'
import React from 'react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import sc from '../classes.scss'
import {useSettings} from '../../../hooks/use-settings'
import settingsParams from '../../../settingsParams'
import {useVisibilityStyles} from '../../hooks/use-visibility-styles'
import s from './main-list-title.scss'
import {MainListTitleProps} from '.'

export const MainListTitle = ({listLayout, mobile, cardsLayout, settings}: MainListTitleProps) => {
  const {get} = useSettings(settings)
  const title = get(settingsParams.listGeneralTitle)
  const {allBreakpoints} = useVisibilityStyles()
  const visible = allBreakpoints.isListMainTitleEnabled()

  if (!visible) {
    return null
  }

  return (
    <h1
      className={classNames(s.title, sc.textLineHeight, {
        [s.mobile]: mobile,
        [s.cards]: cardsLayout,
        [s.listLayout]: listLayout,
        [s.defaultLayout]: !mobile && !listLayout && !cardsLayout,
      })}
      data-hook={DH.listTitle}
    >
      {title}
    </h1>
  )
}
